import { PeriodFilter } from "@/components/shared/PeriodFilter";

export const StatsSummary = ({ loading, overallAverage, period, onPeriodChange }) => (
  <section className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between" data-testid="dashboard-controls-section">
    <div data-testid="dashboard-score-summary">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#8C9B90]" data-testid="dashboard-score-label">Spiritual vitality</p>
      <p className="font-serif-display text-5xl font-semibold text-[#1A3626]" data-testid="dashboard-overall-average">
        {loading ? "—" : overallAverage?.toFixed(2) || "0.00"}
      </p>
    </div>
    <PeriodFilter activePeriod={period} onChange={onPeriodChange} testPrefix="dashboard" />
  </section>
);